import { ADDMEMBERGROUP_SUCCESS, ADDMEMBERGROUP_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const addMemberGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDMEMBERGROUP_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ADDMEMBERGROUP_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default addMemberGroupReducer;
